export const getters = {
  getOrdemServico: (state) => state.ordemServico,
  getOrdensServicos: (state) => state.ordensServicos,
  getModalCadastroOrdemServico: (state) => state.modalCadastroOrdemServico,
  getModalExcluirOrdemServico: (state) => state.modalExcluirOrdemServico,
  getStatusOrdemServico: (state) => state.statusOrdemServico,
  getModalHistoricoStatusOS: (state) => state.modalHistoricoStatusOS,
  getModalPagamentoOrdemServico: (state) => state.modalPagamentoOrdemServico,
};

export default {};